import React, { useState, useEffect, useRef} from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { BaseURL, GpsBaseURL, uniqueToken, Role } from '../../api/DataApis';
import { LuUser2 } from 'react-icons/lu';
import { Link, Navigate, useLocation, useParams } from 'react-router-dom';
import request from '../../Apis/request';
import "./User.css";
import ReactPaginate from 'react-paginate'; 
import { GrTransaction } from 'react-icons/gr';
import Loader from "../Settings/Loader";
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';




  const ExcelLogs = () => {
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [page, setPage] = useState(1); // State for current page
  const [pageCount, setPageCount] = useState(0); 
  const [selectedCorporate, setSelectedCorporate] = useState('');
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [Limit, setLimit] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [Loaders, setLoaders] =  useState(false);
  
 let navigate = useNavigate();
 let location = useLocation();
 let params = useParams();

 let excelLogStatus =  location?.state?.Status;
 console.log("excelLogStatus", excelLogStatus);
 let  viewLogsID = params?.fid;
 console.log("viewLogsID", viewLogsID);
 console.log("filetered-data", filteredData);
 console.log("pageCount", pageCount);
 console.log("Limit", Limit);


 const handleReset = (event) => {
  event.preventDefault();

  // Ensure that Status and other state values are retained
  navigate(`/view-excel-users-logs/${viewLogsID}`, {
      state: { 
          ...location.state, // Preserve existing state values
          Status: location.state?.Status || "failure" // Retain 'failure' if Status is undefined
      }
  });
};
 document.title = "Excel Logs";

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };
 const fetchUsers = async (page) => {
    setLoading(true);
    
    // Base API URL
    let apiEndpoint = decodeURIComponent(`${GpsBaseURL}/excel/users/${viewLogsID}?type=${excelLogStatus}&page=${page}`);
   
    const queryParams = [];
  if (searchQuery) queryParams.push(`&searchText=${searchQuery}`);
    const apiUrl = `${apiEndpoint}${queryParams.join('&')}`;
  
    try {
      const response = await axios.get(apiUrl, {
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${uniqueToken}`, // Replace with actual token if needed
        },
      });
  
      console.log("response", response);
   
       setFilteredData(response?.data?.data);
      setTotalCount(response?.data?.count || 0);
      setLimit(response?.data?.limit);
      setPageCount(Math.ceil(response.data.count / response?.data?.limit)); // Assuming API returns totalCount for pagination
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);

    }
  };
  
  // Re-fetch users whenever searchTerm changes
  useEffect(() => {
    fetchUsers(page);
  }, [searchTerm,  page,]);
  


  const handleChange = (setter) => (event) => {
    setter(event.target.value);
  };
  const handlePageClick = (data) => {
    const selectedPage = data.selected + 1; // ReactPaginate uses zero-based index
    setPage(selectedPage); // Update the current page state
  };

   const handleSearchTextChange = (e) => {
  setSearchQuery(e.target.value);
};

// Handle submit to fetch filtered data
const handleSearchSubmit = async (e) => {
  e.preventDefault(); // Prevent default form submission

  const page = 1; // Always reset to page 1 when searching
  setPage(page); // Ensure pagination resets to the first page

  // Set loading to true while fetching
  setLoading(true); 

  // Prepare the base URL and query parameters
  let url = `${GpsBaseURL}/excel/users/${viewLogsID}?type=${excelLogStatus}&page=${page}`;
  const params = [];

  // Add search term if present
  if (searchQuery.trim()) {
      params.push(`searchText=${searchQuery}`);
  }

  if (params.length) {
      url += `&${params.join('&')}`;
  }

  try {
      const response = await axios.get(url, {
          headers: {
              Authorization: `Bearer ${uniqueToken}`, // Include authorization token
          },
      });

      if (response && response?.data) {
        
        setFilteredData(response?.data?.data);
        setTotalCount(response?.data?.count || 0);
        setLimit(response?.data?.limit);
        setPageCount(Math.ceil(response.data.totalCount / response?.data?.limit));// Update page count based on results
      } else {
          setFilteredData([]); // If no data is returned, set filtered data to empty
          setTotalCount(0); // If no data is returned, set totalCount to 0
      }
      
  } catch (error) {
      console.error("Error fetching filtered data:", error);
  } finally {
      setLoading(false); // Set loading to false after fetching
  }
};




  return (
    <div className='container-fluid'>
      <div className='row'>
        <div className='col-sm-12'>
          <div className='card'>
            <div className="portlet-body mx-3">
            <div className="d-flex justify-content-between align-items-center mb-3">
  <div className="d-flex align-items-center">
    {excelLogStatus === "success" && (
      <>
    <h4 className="mb-0 me-3">Imported User Success Logs({totalCount ? totalCount : "Loading..." })</h4> {/* Add margin to the right of the heading */}
    </>
  )}
     {excelLogStatus === "failure" && (
      <>
    <h4 className="mb-0 me-3">Imported User Failure Logs({totalCount ? totalCount : "Loading..." })</h4> {/* Add margin to the right of the heading */}
    </>
  )}
  </div>


</div>
<hr style={{ marginTop: "0px" }} />
<div className="row">
  <form className="form-horizontal" role="form" style={{ marginTop: "5px" }}>
    <div
      className="row px-3"
      style={{
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap", // Allows wrapping on smaller screens
      }}
    >
   
    
    </div>

    {/* New line for next set of fields */}
    <div
      className="row px-3"
      style={{
        display: "flex",
        flexWrap: "wrap", // Allow wrapping on smaller screens
        marginTop: "10px", // Space between groups
      }}
    >


      <div className="col-md-2 col-sm-12">
        <div className="form-group">
          <input
            placeholder="Find Data Here"
            className="form-control"
            style={{
              borderRadius: "8px",
              padding: "6px 10px",
              marginRight: "10px",
              height: "38px",
            }}
            value={searchQuery}
            onChange={handleSearchTextChange}
          />
        </div>
      </div>


      <div
        className="col-md-2 col-sm-12"
        style={{ display: "flex", alignItems: "center" }}
      >
        <button
          className="btn btn-primary"
          onClick={handleSearchSubmit}
          style={{
            marginLeft: "10px",
            height: "38px",
            width: "80px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: 0,
          }}
        >
          Search
        </button>

        <button
          className="btn btn-primary"
          onClick={handleReset}
          style={{
            marginLeft: "10px",
            height: "38px",
            width: "80px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: 0,
          }}
        >
          Reset
        </button>
     
      </div>
    </div>
  </form>
</div>




<div className="card-body" style={{ marginLeft: "-19px" }}>
  {loading ? (
    <Loader />
  ) : totalCount === 0 ? (
    <div className="text-center">
      <h5>No Logs Found</h5>
    </div>
  ) : (
    <>
    <div className="table-responsive">
      <table
        className="display dataTable"
        id="advance-1"
        style={{ tableLayout: 'auto', width: '100%', borderCollapse: 'collapse' }}
      >
       <thead>
  <tr>


    <th style={{ minWidth: '80px' }}>Sr No</th>
    <th style={{ minWidth: '200px' }}>Name</th>
    <th style={{ minWidth: '100px' }}>Email</th>
    <th style={{ minWidth: '100px' }}>Mobile No</th>
    <th style={{ minWidth: '100px' }}>Address</th>
  </tr>
</thead>

        <tbody>
          {filteredData?.map((user, index) => (
            <tr key={index}>
  

              <td>{(page - 1) * Limit + index + 1}</td>
              <td>{user?.name}</td>

<td>{user?.email}</td>
<td>{user?.mobile}</td>
<td>{user?.address}</td>
            </tr>
          ))}
        </tbody>
      </table>
</div>
    <div className="pagination-container mt-4">
        <ReactPaginate
          previousLabel={'Previous'}
          nextLabel={'Next'}
          breakLabel={'...'}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={handlePageClick}
          containerClassName={'pagination'}
          subContainerClassName={'pages pagination'}
          activeClassName={'active'}
          forcePage={page - 1} 
        />
      </div>
    </>
  )}
</div>


 </div>
      </div>
    </div>
  </div>
</div>
  );
};

export default ExcelLogs;
